import { Box } from '@material-ui/core';
import { formatMoney } from '@nemuru-eng/js-api-client';

import { CartItemDialogClose } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartItemDialog/components/CartItemDialogClose';
import { CartItemDialogConfirmationDialog } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartItemDialog/components/CartItemDialogConfirmationDialog';
import { CartItemDialogForm } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartItemDialog/components/CartItemDialogForm';
import { CartItemDialogTotal } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartItemDialog/components/CartItemDialogTotal';
import { useCartItemDialog } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartItemDialog/hooks/useCartItemDialog';
import { CartFormActions } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/CartFormActions';
import { MinimalFormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/MinimalFormItem';
import { getTotalPrice } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/utils/getTotalPrice';
import { Font } from '@/components/shared/components/Font';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';
import { useScreen } from '@/hooks/useScreen';

export interface CartItemDialogProps {
  index: number;
  items: MinimalFormItem[];
  cartFormActions: CartFormActions;
  open: boolean;
  setOpen: (open) => void;
}

export const CartItemDialog = ({ index, items, cartFormActions, open, setOpen }: CartItemDialogProps) => {
  const {
    state: { cart },
  } = useApplicationContext();

  const { sm } = useScreen();
  const {
    currentFormItem,
    onClose,
    handleClose,
    handleSave,
    handleSaveAndAddItem,
    loadingSubmit,
    selectableArticleTypes,
    confirmationDialogOpen,
    setConfirmationDialogOpen,
    isFormValid,
  } = useCartItemDialog({ index, items, cartFormActions, open, setOpen });

  if (!cart) return null;

  return (
    <>
      <NemuruDialog
        avoidDefaultClose
        removeDefaultButton
        opened={open}
        setOpened={setOpen}
        onClose={handleClose}
        buttons={
          <>
            <StandardButton onClick={handleSaveAndAddItem}>
              {!sm ? <Text tId={'NEW_ITEM'} /> : <Text tId={'SAVE_AND_NEW_ITEM'} />}
            </StandardButton>
            <StandardButton variant={'contained'} onClick={handleSave} loading={loadingSubmit} disabled={!isFormValid}>
              <Text tId={'SAVE'} />
            </StandardButton>
          </>
        }
      >
        <Box
          mb={4}
          flexGrow={1}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}
          position={'relative'}
        >
          <Font variant={'h3'} color={'title'}>
            <Text tId={'ARTICLE_INFORMATION'} />
          </Font>
          <CartItemDialogClose onClick={handleClose} />
        </Box>
        <CartItemDialogForm selectableArticleTypes={selectableArticleTypes} />
        <CartItemDialogTotal
          price={formatMoney({ value: getTotalPrice(currentFormItem), currency: cart.currency }, 2)}
        />
      </NemuruDialog>
      <CartItemDialogConfirmationDialog
        opened={confirmationDialogOpen}
        setter={setConfirmationDialogOpen}
        onConfirm={onClose}
      />
    </>
  );
};
